import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SundayRaffleDetailPage } from './sunday-raffle-detail';
import { SundayRaffleComponent } from '../sunday-raffle/sunday-raffle';

@NgModule({
  declarations: [
    SundayRaffleComponent,
    SundayRaffleDetailPage,
  ],
  imports: [
    IonicPageModule.forChild(SundayRaffleDetailPage),
  ],

  exports:[
    SundayRaffleComponent,
    
  ]
})
export class SundayRaffleDetailPageModule {}



// WEBPACK FOOTER //
// ./src/app/lottery/sunday-raffle-detail/sunday-raffle-detail.module.ts